 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","concat":"concat","renyiOverview":"renyiOverview","renyiTheatre":"renyiTheatre","theatreMuseum":"theatreMuseum"}[chunkId]||chunkId) + "." + {"about":"e77fff05","chunk-054426fe":"3a56a2de","chunk-05966c10":"35937fb2","chunk-08d7fbae":"2f0e0460","chunk-0aa42bb8":"e03b3fe4","chunk-0d1ed754":"2754682b","chunk-16200aee":"076fa6fb","chunk-190189c6":"ae31eb69","chunk-1fc95f48":"df7f3f6d","chunk-23f4244a":"9a6baf3e","chunk-2d0a2de6":"ec8385aa","chunk-2d0c422c":"dedaf27c","chunk-2d0e9ae8":"cc4478b6","chunk-2d21310c":"835e2038","chunk-2d21f0dc":"14d538eb","chunk-2de54de8":"887a5228","chunk-2df7b0e2":"601cb9b5","chunk-2ebef840":"d169152f","chunk-3d6d4837":"a6f2df2c","chunk-40053175":"301fed09","chunk-43a433ae":"971da8d9","chunk-45756ccc":"5e1aa784","chunk-45db7ee8":"02de2b8f","chunk-45eca664":"816e40ca","chunk-478cd72a":"beeb166f","chunk-496bff85":"229e75d7","chunk-4abbc2da":"e76de823","chunk-4b4c279b":"9f8b0908","chunk-4c2d63de":"e08f2608","chunk-4e146dc1":"4e0cc6c2","chunk-55a6ada8":"c23a002c","chunk-5a88ba43":"404e0f26","chunk-5b4f034d":"78350326","chunk-5d0efb84":"50795aec","chunk-5db2df01":"fae4d0a4","chunk-6813c331":"8f82f77b","chunk-6c59624d":"d7f5bb89","chunk-70504101":"6fab2dbc","chunk-73b834c4":"99fc9f6a","chunk-74a8feac":"a2fa1993","chunk-780466dc":"2b7505e7","chunk-3b5aa720":"846a2f83","chunk-7dfcc7a0":"63b599e2","chunk-7a08a694":"e985a936","chunk-7b2492f6":"cd67777f","chunk-7ccf713b":"6a49d8e5","chunk-86fa61fe":"487a9e5c","chunk-93914e86":"fbb1f0a3","chunk-a2299782":"98cf9497","chunk-afab38ba":"f3eb6ed9","chunk-cd75f316":"9c4d5570","chunk-dcafadce":"3bd27b33","chunk-eebcff84":"80273ff7","chunk-f6a265d2":"52684632","concat":"29ef3d1a","renyiOverview":"3c634a3c","renyiTheatre":"72174f87","theatreMuseum":"7f97f194"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"chunk-054426fe":1,"chunk-05966c10":1,"chunk-08d7fbae":1,"chunk-0aa42bb8":1,"chunk-0d1ed754":1,"chunk-16200aee":1,"chunk-190189c6":1,"chunk-1fc95f48":1,"chunk-23f4244a":1,"chunk-2de54de8":1,"chunk-2df7b0e2":1,"chunk-2ebef840":1,"chunk-3d6d4837":1,"chunk-40053175":1,"chunk-43a433ae":1,"chunk-45756ccc":1,"chunk-45db7ee8":1,"chunk-45eca664":1,"chunk-478cd72a":1,"chunk-496bff85":1,"chunk-4abbc2da":1,"chunk-4b4c279b":1,"chunk-4c2d63de":1,"chunk-4e146dc1":1,"chunk-55a6ada8":1,"chunk-5a88ba43":1,"chunk-5b4f034d":1,"chunk-5db2df01":1,"chunk-6813c331":1,"chunk-6c59624d":1,"chunk-70504101":1,"chunk-73b834c4":1,"chunk-74a8feac":1,"chunk-3b5aa720":1,"chunk-7dfcc7a0":1,"chunk-7a08a694":1,"chunk-7ccf713b":1,"chunk-86fa61fe":1,"chunk-93914e86":1,"chunk-a2299782":1,"chunk-afab38ba":1,"chunk-cd75f316":1,"chunk-dcafadce":1,"chunk-eebcff84":1,"chunk-f6a265d2":1,"concat":1,"renyiOverview":1,"renyiTheatre":1,"theatreMuseum":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","concat":"concat","renyiOverview":"renyiOverview","renyiTheatre":"renyiTheatre","theatreMuseum":"theatreMuseum"}[chunkId]||chunkId) + "." + {"about":"a3ccd4f1","chunk-054426fe":"6ae6b103","chunk-05966c10":"4ffedb02","chunk-08d7fbae":"8380ec5a","chunk-0aa42bb8":"430d7385","chunk-0d1ed754":"07d71392","chunk-16200aee":"c82f9fc7","chunk-190189c6":"c717fd22","chunk-1fc95f48":"d8297562","chunk-23f4244a":"2df7fcf6","chunk-2d0a2de6":"31d6cfe0","chunk-2d0c422c":"31d6cfe0","chunk-2d0e9ae8":"31d6cfe0","chunk-2d21310c":"31d6cfe0","chunk-2d21f0dc":"31d6cfe0","chunk-2de54de8":"12bc44a3","chunk-2df7b0e2":"d08d7f43","chunk-2ebef840":"995f9ec8","chunk-3d6d4837":"2d03fcbc","chunk-40053175":"f64ee737","chunk-43a433ae":"6e6ca008","chunk-45756ccc":"9d5dddd1","chunk-45db7ee8":"3168b133","chunk-45eca664":"7055fed3","chunk-478cd72a":"6e6cc282","chunk-496bff85":"edc26a09","chunk-4abbc2da":"fb51f13d","chunk-4b4c279b":"f134ded8","chunk-4c2d63de":"ca036e51","chunk-4e146dc1":"828847ac","chunk-55a6ada8":"a4271b55","chunk-5a88ba43":"6412b42c","chunk-5b4f034d":"ffb9804a","chunk-5d0efb84":"31d6cfe0","chunk-5db2df01":"23596f95","chunk-6813c331":"321dc7d6","chunk-6c59624d":"ce66b9e6","chunk-70504101":"0cf781f5","chunk-73b834c4":"d419fab0","chunk-74a8feac":"b50c2132","chunk-780466dc":"31d6cfe0","chunk-3b5aa720":"2ab98729","chunk-7dfcc7a0":"e601f628","chunk-7a08a694":"2b5f04e8","chunk-7b2492f6":"31d6cfe0","chunk-7ccf713b":"9d84844f","chunk-86fa61fe":"368b821b","chunk-93914e86":"33e780a3","chunk-a2299782":"285dbce4","chunk-afab38ba":"d8eca575","chunk-cd75f316":"6b08aabd","chunk-dcafadce":"142263a2","chunk-eebcff84":"750cf7a8","chunk-f6a265d2":"e7e3a75c","concat":"9f5d72b8","renyiOverview":"94763de0","renyiTheatre":"b938b6f5","theatreMuseum":"e3a22def"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/newWeb/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
